import { createGlobalState } from './createGlobalState';
import { Environment } from 'core/models/environment';
import { useEffect, useCallback } from 'react';
import useLocalStorage from 'react-use/lib/useLocalStorage';
import { ignore } from 'utility/ignore';

const { useWithState, useDispatch, useState } = createGlobalState<Environment | null>((_, a) => a, null);

type EnvironmentSelection = {
    environmentId: Environment.Id;
}

const ASSIGNED_ENVIRONMENTS_KEY = 'jp.tier4.drive.autoware.selected.environment';

function useSelectedEnvironment(environments: Environment[]) {
    const selectedEnvironment = useState();
    const select = useDispatch();
    const [stored, store] = useLocalStorage<EnvironmentSelection | null>(ASSIGNED_ENVIRONMENTS_KEY, null);

    useEffect(() => {
        if (selectedEnvironment) return;

        if (!stored) return;
        if (environments === undefined || environments.length == 0) return;

        const lastEnvironment = environments.find(env => env.id == stored.environmentId);
        if (lastEnvironment) {
            select(lastEnvironment);
        } else {
            store({ environmentId: environments[0].id });
            select(environments[0]);
        }
    }, [environments, select, selectedEnvironment, store, stored]);

    return selectedEnvironment;
}

function useSelectEnvironment() {
    const select = useDispatch();
    const [stored, store] = useLocalStorage<EnvironmentSelection | null>(ASSIGNED_ENVIRONMENTS_KEY, null);
    ignore(stored);

    return useCallback((environment: Environment | null) => {
        if (environment) {
            store({ environmentId: environment.id });
        }
        select(environment);
    }, [select, store]);
}

export {
    useWithState as useWithSelectedEnvironment,
    useSelectedEnvironment,
    useSelectEnvironment
};
